import { render } from "./SkipLinks.vue?vue&type=template&id=c7a08fee&scoped=true"
import script from "./SkipLinks.vue?vue&type=script&lang=js"
export * from "./SkipLinks.vue?vue&type=script&lang=js"

import "./SkipLinks.vue?vue&type=style&index=0&id=c7a08fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a08fee"]])

export default __exports__